import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, Search, ArrowDropDown, PhoneInTalkOutlined } from '@material-ui/icons';
import { NavLink } from 'react-router-dom';

const { Option } = Select;

function UserFilter({ intl, searchText, onStateFilter, onSort, onSearch, onKeyDownSearch, onApplyFilter }) {
  const userStates = [
    { value: 'O', label: intl.formatMessage({ id: 'All' }) },
    { value: 'A', label: intl.formatMessage({ id: 'Active' }) },
    { value: 'I', label: intl.formatMessage({ id: 'Inactive' }) },
    { value: 'D', label: intl.formatMessage({ id: 'Deleted' }) },
    { value: 'P', label: intl.formatMessage({ id: 'En seguimiento' }) },
  ];
  const userSorts = [
    { value: 'state desc', label: intl.formatMessage({ id: 'By state' }) },
    { value: 'id desc', label: intl.formatMessage({ id: 'By ID' }) },
    {
      value: 'lastOrderedAt desc',
      label: intl.formatMessage({ id: 'By date of last order placed' }),
    },
  ];
  const handleStateFilter = values => {
    onStateFilter(values);
  };

  const handleSort = value => {
    onSort(value);
  };

  const handleSearch = e => {
    onSearch(e);
  };

  return (
    <div className="user_filter_layout">
      <Select
        className="active_states"
        suffixIcon={<ArrowDropDown />}
        // mode="multiple"
        placeholder="estados activos"
        onChange={handleStateFilter}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {userStates.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder="Ordernar por"
        onChange={handleSort}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {userSorts.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter}>
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <NavLink to="/dashboard/users/manage" style={{ textDecoration: 'none' }}>
        <Button className="manage_phone_number_btn">
          <FormattedMessage id="Manage phone numbers" />
          <PhoneInTalkOutlined />
        </Button>
      </NavLink>
      <Input
        suffix={<Search />}
        placeholder="Buscar usuario"
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => onKeyDownSearch(e)}
      />
    </div>
  );
}

export default compose(injectIntl)(UserFilter);
